exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}.QHFKQ0-vFu9sapY9DTuGqw\\=\\={-webkit-box-align:center;-ms-flex-align:center;align-items:center}._82bHIVVZ2IyBkclNBqYnHQ\\=\\={-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}", ""]);
// Exports
exports.locals = {
	"itemContainer": "QHFKQ0-vFu9sapY9DTuGqw==",
	"textContainer": "_82bHIVVZ2IyBkclNBqYnHQ=="
};